export default "__VITE_ASSET__8YuNidI4__"